import { cloneDeep } from "lodash-es";
import { IFurniture } from "../data/model/furniture";
import { getUniqueId } from "../utils";
import { globalStores, TGlobalStores } from "../stores";
import { createModelGroupData } from "../data/modelGroup/utils";
import { EModelGroupType } from "../data/type";
import { IModelGroupData } from "../data/modelGroup/modelGroup";
import { EOperationType } from "../types/operation";
import { modelManager } from "../manager/entityManager";

export class ModelGroupOperation {
  private _modelGroupStore: TGlobalStores["modelGroupStore"];
  private _history: TGlobalStores["history"];

  constructor(gs: TGlobalStores) {
    this._modelGroupStore = gs.modelGroupStore;
    this._history = gs.history;
  }

  private $history_modifyModelGroup(
    modelGroupId: string,
    modelGroupData: Partial<IModelGroupData>,
  ) {
    this._history.startOperation();
    this._modelGroupStore.updateModelGroupData(modelGroupId, modelGroupData);
    this._history.completeOperation(EOperationType.ModelGroupModify);
  }

  createModelGroupData(baseData: IFurniture, distance: number) {
    const datas: IFurniture[] = [];
    datas.push(baseData);
    const count = Math.floor(distance / baseData.width);
    for (let i = 1; i < count + 1; i++) {
      const copyData = cloneDeep(baseData);
      copyData.id = getUniqueId();
      copyData.center.x = baseData.center.x + i * baseData.width;
      datas.push(copyData);
    }
    for (const data of datas) {
      globalStores.modelStore.addFurnitureData(data);
    }

    const modelGroupData = createModelGroupData(
      baseData,
      datas,
      EModelGroupType.furniture,
      0,
      0,
    );

    globalStores.modelGroupStore.addModelGroupData(modelGroupData);

    return modelGroupData;
  }

  modifyModelGroup(
    modelGroupId: string,
    modelGroupData: Partial<IModelGroupData>,
  ) {
    this.$history_modifyModelGroup(modelGroupId, modelGroupData);
    modelManager.modelGroupManager.updateModelGroup({ id: modelGroupId });
  }
}
